export default {
	FILTER_PADDING: 4,
	CELL_CHART_PADDING: 4,
	DASHBOARD_COLUMNS: 36,
	DASHBOARD_ITEM_GAP: 10,
}
